import { useQueries } from "react-query";
import { createProfileLink } from "../../helpers/cosmos-profile-link";

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export const localizeDate = (date, locale) => {
  return new Date(date).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export async function getBlogById(contentId) {
  const url = `/rest/api/search?cql=type=blogpost and id=${contentId}&limit=1&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch blogpost", contentId);
    console.log(e);
    return undefined;
  }
}

export async function getPageById(contentId) {
  const url = `/rest/api/search?cql=type in (page, blogpost) and id=${contentId}&limit=1&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;

  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch page", contentId);
    console.log(e);
    return undefined;
  }
}

export const mapPage = (page, locale, isCosmosInstalled) => ({
  id: page.content.id,
  type: page.content.type,
  name: page.content.title,
  numberOfComments: page.content.children.comment.results.length,
  numberOfLikes: page?.content?.metadata?.likes?.count,
  labels: page.content.metadata?.labels?.results.map((l) => l.label) ?? [],
  space: { name: page.content.space.name },
  spaceUrl: `${window.AP._hostOrigin}/wiki${page.content.space._links.webui}`,
  excerpt: htmlDecode(page.excerpt),
  url: `${window.AP._hostOrigin}/wiki${page.url}`,
  editUrl: `${window.AP._hostOrigin}/wiki/spaces/${page.content.space.key}/${
    page.content.type === "blogpost" ? "blog" : "pages"
  }/edit-v2/${page.content.id}`,
  createdBy: page.content.history.createdBy.displayName,
  created: localizeDate(page.content.history.createdDate, locale || "en-US"),
  authorUrl: isCosmosInstalled
    ? createProfileLink(page.content.history.createdBy.accountId)
    : `${window.AP._hostOrigin}/wiki/people/${page.content.history.createdBy.accountId}`,
  lastModified: page.friendlyLastModified,
  avatarUrl: `${window.AP._hostOrigin}${page.content.history.createdBy.profilePicture.path}`,
});

export const usePages = (data, locale, isCosmosInstalled) =>
  useQueries(
    data.map((page) => {
      return {
        queryKey: ["page", page.contentId, page.id],
        queryFn: () => {
          if (page?.contentId === 0 || !page.contentId) {
            return { isNew: true, loading: false, id: page.id, name: "" };
          }
          return getPageById(page.contentId);
        },
        retry: 0,
        placeholderData: {
          contentId: page.contentId,
          name: "",
          loading: true,
          isPlaceholder: true,
        },
        select: (response) => {
          if (response.isPlaceholder || response.isNew) {
            return response;
          }
          const body = JSON.parse(response.body);
          const result = body.results.map((p) => {
            return {
              ...mapPage(p, locale, isCosmosInstalled),
              id: data.find((x) => x.id.toString() === page.id).id,
            };
          });
          return result[0];
        },
      };
    })
  );
